import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/about/AboutClient.tsx");
